module.exports = __webpack_public_path__ + "img/etoget.d6395d49.jpg";